import { AssemblePayloadRequest, DynamicIndexObjectType, IDeviceControlTransaction, MapLike, matchObjectKeys, ValidBusinessObject } from '@iotv/iotv-v3-types'
import { UserAttributeDef, UserAttributeDefs } from '../../types'
import { getTTLSeconds } from '../../util/time/millisecondOperations'
import { getDateUserAttribute } from '../commonAttributeSets/commonAttributeTypes'
import { ITTL } from '../Interfaces/TimeRelated'
import { ModelCommon } from '../ModelCommon'
import { DeviceControlTransactionProps, DeviceControlTransactionStage, DeviceTransactionStatus } from '@iotv/iotv-v3-types'
import { getMinimalValidDeviceObject } from '../../ModelClassInterfaces'

const className = 'DeviceControlTransaction'

// dpk: DeviceID ( the id not the eui )
// dsk: timestamp

export class DeviceControlTransaction extends ModelCommon implements DynamicIndexObjectType, ITTL, IDeviceControlTransaction {
  constructor({
    ttl,
    devicePk,
    status,
    initialRequest,
    requestInitiator,
    timestamp,
    transactionStages,
    broadcastScheduleSk,
    AWS_MessageId,
    ...others
  }: DeviceControlTransactionProps) {
    super(className, { ...others })

    /* 2025 04 device attributes minimized for storage.
            this mimimal device can be used for system operation and retrieval.
            do not use as a proxy for the latest device data.
        */
    const { device } = initialRequest
    initialRequest.device = getMinimalValidDeviceObject(device) ?? device

    ;(this.ttl = ttl), (this.pk = devicePk ?? others.pk)
    ;(this.status = status), (this.initialRequest = initialRequest)
    this.requestInitiator = requestInitiator
    this.timestamp = timestamp
    this.transactionStages = transactionStages ?? []
    this.broadcastScheduleSk = broadcastScheduleSk
    this.AWS_MessageId = AWS_MessageId

    this.ttl = getTTLSeconds(1)
  }

  ttl: number
  dpk?: string
  dsk?: string
  pk: string
  status: DeviceTransactionStatus
  initialRequest: AssemblePayloadRequest
  iniitalPayloadStr?: string
  requestInitiator: ValidBusinessObject
  timestamp: number
  broadcastScheduleSk?: string
  transactionStages: DeviceControlTransactionStage[]
  AWS_MessageId?: string | undefined

  getUserAttributes(): { [k in keyof DeviceControlTransactionProps]?: UserAttributeDef } {
    const atts: UserAttributeDefs = {
      ...super.getUserAttributes(),
      status: {
        type: 'Enum',
        label: 'Status',
        editable: false,
        enumKv: DeviceTransactionStatus,
      },
      initiator: {
        type: 'String',
        label: 'Iniitiator',
        editable: false,
        valueFn: () => this.requestInitiator?.name,
      },
      initialRequest: {
        type: 'object',
        label: 'Request',
        editable: false,
      },
      timestamp: { ...getDateUserAttribute('timestamp', 'Timestamp'), type: 'Date', editable: false },
      transactionStages: { type: 'object', label: 'Stages', editable: false },
    }

    return atts
  }
}

const DeviceControlTranasactionMatcher: Partial<IDeviceControlTransaction & ValidBusinessObject> = {
  initialRequest: undefined,
  pk: undefined,
  requestInitiator: undefined,
  status: undefined,
  timestamp: undefined,
  transactionStages: undefined,
  ttl: undefined,
  type: 'DeviceControlTransaction',
}

export const isDeviceControlTranasaction = (object: MapLike<any>): object is IDeviceControlTransaction => {
  return matchObjectKeys(DeviceControlTranasactionMatcher, object)
}
